module.exports = __webpack_public_path__ + "static/media/TA272_1.fb986d2c.png";